export default function (self) {
  let allFields = [];

  allFields.push({
    title: `Event › Start`,
    minimum: 1,
    maximum: 1,
    key: "join_event.startDate",
    type: "date",
    filterIncludeTime: true,
  });

  allFields.push({
    title: `Event › Doors Open`,
    minimum: 1,
    maximum: 1,
    key: "join_event.openDate",
    type: "date",
    filterIncludeTime: true,
  });

  allFields.push({
    title: `Event › Doors Close`,
    minimum: 1,
    maximum: 1,
    key: "join_event.closeDate",
    type: "date",
    filterIncludeTime: true,
  });

  allFields.push({
    title: `Event › End`,
    minimum: 1,
    maximum: 1,
    key: "join_event.endDate",
    type: "date",
    filterIncludeTime: true,
  });

  allFields.push({
    title: `Event › Type`,
    minimum: 1,
    maximum: 1,
    key: "join_event.meta.definition",
    type: "string",
    widget: "type-select",
    definedParentType: "event",
  });

  return allFields;
}
